import { TPaymentDataSource } from '../types/PaymentKindStrategy';
import {
  batchGroupsSource,
  pendingScheduledPaymentActionsSource,
  scheduledPaymentsSource,
  scheduledWalletTransfersSource
} from './paymentDataSourceExtensions';

/**
 * Every independently-fetched source feeding the merged Manage Payment list (see
 * fetchPaymentsByGroup, which just does `Promise.allSettled` over this array then merges/buckets
 * the results). This file is just the ordered list ("process") - the actual per-source
 * implementations live in paymentDataSourceExtensions.ts, so adding a new source means adding a
 * new export there and one entry here, never editing this list's own logic. See the README's
 * "Extending: Adding a New Row Kind" section.
 *
 * Order matters only in that it's preserved into the merged `items` list (and from there into
 * each tab's row order) - not a behavioural dependency, just what a few tests' row-order
 * assertions currently expect.
 */
export const PAYMENT_DATA_SOURCES: TPaymentDataSource[] = [
  batchGroupsSource,
  scheduledPaymentsSource,
  pendingScheduledPaymentActionsSource,
  scheduledWalletTransfersSource
];
